<div class="search-criteria panel panel-info border-0" style="border: none;">
    <div class="card-body">
        <quick-search-criteria [isOpen]="isOpen"
                               [criteria]="criteria"
                               (criteriaChange)="criteriaChanged($event)"
                               (search)="search()"
                               [resultTypes]="resultTypes">
        </quick-search-criteria>
    </div>
</div>
